import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getDraftProcesses(input) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/partial-form-data/processes?" + input, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching processes"
                });
            }
        });
    },
    getDraftsData(input) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/partial-form-data/drafts?" + input, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching processes"
                });
            }
        });
    },
    getMyProcesses(input) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/tasks-api/process-info?" + input, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching tasks"
                });
            }
        });
    },
    getProcessData(input, filterVariables) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/tasks-api/assigned?" + input, filterVariables, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching tasks"
                });
            }
        });
    },
    getInvolvedUsers(taskId) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + `/tasks-api/users/data/${taskId}`, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting form data"
                });
            }
        });
    },
    getComments(taskId) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + `/tasks-api/${taskId}/comments`, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting form data"
                });
            }
        });
    },
    deleteInvolvedUser(taskId,obj) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + `/tasks-api/${taskId}/remove-user`, obj, {
            withCredentials: true,            
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while deleting involved user"
                });
            }
        });
    },
    postComments(taskId, obj) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + `/tasks-api/${taskId}/comments`, obj, {
            withCredentials: true,            
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Comment cannot be added as task is completed."
                });
            }
        });
    },
    getTaskDetails(taskId) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + `/tasks-api/${taskId}`, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting form data"
                });
            }
        });
    },
    getTaskEvents(taskId) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + `/tasks-api/events/${taskId}`, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting form data"
                });
            }
        });
    },
    getTaskAttachments(taskId) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + `/tasks-api/task-attachments/data/${taskId}`, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting form data"
                });
            }
        });
    },
    getFormForTask(taskId, isExternal) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(isExternal ? constants.BASE_URL + `/standalone/external/tasksAPI/${taskId}/getTaskForm` :constants.BASE_URL + `/tasks-api/${taskId}/task-form`, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting form data"
                });
            }
        });
    },
    getUnclaimedTasks(input) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/tasks-api/available?" + input, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching tasks"
                });
            }
        });
    },
    getUsers() {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/processesAPI/getAllUsers", {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting users"
                });
            }
        });
    },
    saveForLater(url, partialFormInfoDTO) {
        axios.defaults.withCredentials = true;
        if(url == "save"){
            if(partialFormInfoDTO.processDefinitionId.includes(".")){
                partialFormInfoDTO.processDefinitionId = partialFormInfoDTO.processDefinitionId.split(".")[0];
            }
            return axios.post(constants.BASE_URL + "/partial-form-data", partialFormInfoDTO).then(response => {
                return response.data;
    
            }).catch(error => {
                return error.response;
            }); 
        }
        else{
            return axios.put(constants.BASE_URL + "/partial-form-data", partialFormInfoDTO).then(response => {
                return response.data;
    
            }).catch(error => {
                return error.response;
            });
        }
    },
    deleteDraft(draftId) {
        axios.defaults.withCredentials = true;
        return axios.delete(constants.BASE_URL + "/partial-form-data/"+draftId).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": "Error while deleting draft"
            });
        });
    },
    submitTask(url, obj) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(url, obj, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while submitting form data"
                });
            }
        });
    },
    addAttachment(taskId, obj) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + `/tasks-api/${taskId}/add-attachment`, obj, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while adding attachment"
                });
            }
        });
    },
    claimUnclaimOperation(taskId, operation) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + `/tasks-api/${taskId}/${operation}`, {}, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
        });
    },
    delegateReassigneeTask(taskId, obj, operation) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + `/tasks-api/${taskId}/${operation}`, obj, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
        });
    },
    addAttachmentWithExternalSystem(taskId, obj) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + `/tasks-api/${taskId}/add-external-resource-attachment`, obj, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while adding attachment"
                });
            }
        });
    },
    deleteAttachment(taskId, attachmentId) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + `/tasks-api/${taskId}/delete-attachment/${attachmentId}`, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while deleting attachment"
                });
            }
        });
    },
    getProcesses() {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/process-engine/tasks/all-processes", {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        });
    },
    getAllTasks(input, filterVariables) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/process-engine/tasks/all-tasks?" + input, filterVariables, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching tasks"
                });
            }
        });
    }
}
